@if (loading()) {
  <div class="loading-screen">
    <app-loading-indicator [@loadingScreen]></app-loading-indicator>
  </div>
} @else {
  <div class="section dark" [@emptyParent]>
    @if (showSidebar) {
      <div class="sidebar" [@sidebar]>
        <app-advanced-mode-sidebar
          [gallery]="gallery()"
          [sections]="sections"
          [assets]="assets"
          [_assets]="_assets"
          [searchTerm]="searchTerm"
          [filters]="filters"
          [galleryPermissions]="galleryPermissions()"
          [people]="people"
          [allowedFeedbackOptions]="allowedFeedbackOptions()"
          [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
          [colorLabels]="colorLabels()"
          [isDesktop]="isDesktop"
          (onFilterChange)="filterChange()"
          (onSelectAll)="selectAll()"
          #sidebar
        >
        </app-advanced-mode-sidebar>
      </div>
    }
    <div class="content" [@content]="showSidebar ? 'to' : 'from'" #content>
      @if (browserPlatform) {
        <app-advanced-mode-content-header
          [assets]="assets"
          [sections]="sections"
          [gallery]="gallery()"
          (onHeaderToggle)="onSideMenuToggle()"
          [assetSize]="assetTargetSize"
          [assetMinSize]="assetMinSize"
          [assetMaxSize]="assetMaxSize"
          [allowSidebar]="true"
          [showSidebar]="showSidebar"
          [clientMode]="clientMode"
          (onAssetSizeChange)="changeAssetSize($event)"
          (onSearch)="search($event)"
          (onSortingChange)="changeSorting($event)"
          (onGroupingChange)="changeGrouping($event)"
          [sorting]="sorting"
          [grouping]="grouping"
          #header
        >
        </app-advanced-mode-content-header>
      }
      @if (!browserPlatform) {
        <div class="assets-placeholder"></div>
      }
      @if (browserPlatform) {
        <app-drop
          (onFileDrop)="uploadAssets($event)"
          (onFileUrlDrop)="uploadAssets($event)"
          [borderStyle]="'full'"
          [hoverStyle]="'white'"
          [style.--gallery-background-color]="'transarent'"
          [disable]="!galleryPermissions().can_edit"
          [darkBackground]="true"
          [default]="true"
        >
          @if (!assets.length && !_assets.length && galleryPermissions().can_edit) {
            <div class="no-assets-found">
              <div class="no-assets-content">
                <label for="asset-upload">
                  <img src="/assets/icons/special/image-stack-upload.svg" class="upload-icon" alt="" />
                </label>
                <h2>Upload Media</h2>
                <input
                  type="file"
                  id="asset-upload"
                  class="hidden-input"
                  (change)="uploadAssetEvent($event.target)"
                  accept="image/*"
                  #uploadEl
                  multiple
                />
                <div class="drop-assets-text-with-button">
                  Drop or<label
                    appButton
                    name="select-assets"
                    location="advanced-mode"
                    color="simple-primary"
                    height="0"
                    spacing="1"
                    shape="small"
                    for="asset-upload"
                    >Select Media</label
                  >
                </div>
              </div>
            </div>
          }
          @if (!assets.length && !!_assets.length) {
            <div class="no-assets-found">
              <div class="no-assets-content">
                <img src="/assets/icons/special/image-search-dots.svg" [width]="96" [height]="96" alt="" />
                <h2>No Results</h2>
                <p>No matching assets found. Try removing some filters or reset them all below.</p>
                <button
                  appButton
                  name="reset-filters"
                  location="advanced-mode"
                  [hasIcon]="true"
                  (click)="resetFilters()"
                  [center]="true"
                >
                  <app-svg src="/assets/icons/undo.svg"></app-svg>
                  <span>Reset Filters</span>
                </button>
              </div>
            </div>
          }
          @if (assets.length && _assets.length) {
            <div class="asset-groups" #el (click)="unselectAll()">
              @if (dragging) {
                <div class="dragging-assets">
                  @for (asset of getSelectedItems(4); track asset.id; let i = $index) {
                    @if (asset | canDisplayAsset) {
                      <img
                        [src]="
                          asset.version_data
                            | assetVersionUrl
                              : asset
                              : asset.version_data.status
                              : cellSize
                              : cellSize
                              : !!gallery().watermark
                        "
                        alt=""
                        [style.left]="mousePos.x + 'px'"
                        [style.top]="mousePos.y + 'px'"
                      />
                    } @else {
                      <div [style.left]="mousePos.x + 'px'" [style.top]="mousePos.y + 'px'" class="broken-image">
                        <app-svg src="/assets/icons/image-refresh.svg"></app-svg>
                      </div>
                    }
                  }
                </div>
              }
              @for (group of assetGroups; track group.id; let groupIndex = $index) {
                <div class="asset-group" id="group-{{ groupIndex }}">
                  @if (!group.assets.length && !filters.length) {
                    <div class="empty-group">Empty section</div>
                  }
                  @if (grouping && (assetGroups.length > 1 || grouping !== 'section') && group.assets.length) {
                    <div class="asset-group-header">
                      @if (grouping === 'section') {
                        <app-svg src="/assets/icons/image-stack.svg" color="gray"></app-svg>
                      } @else if (grouping === 'status') {
                        <app-svg
                          [src]="'/assets/icons/' + (group.status | assetStatusIcon) + '.svg'"
                          [attr.color]="(group.status | assetStatusColor) || 'grey-50'"
                        >
                        </app-svg>
                      } @else if (grouping === 'color_label' && group.label) {
                        <app-svg src="/assets/icons/color-label-filled.svg" [attr.color]="group.label.color"></app-svg>
                      } @else if (grouping === 'color_label' && !group.label) {
                        <app-svg src="/assets/icons/color-label-dotted.svg" [attr.color]="'gray'"></app-svg>
                      } @else if (grouping === 'likes' && group['likes'] > 0) {
                        <app-svg src="/assets/icons/heart-filled.svg" color="warn"></app-svg>
                      } @else if (grouping === 'likes' && group['likes'] === 0) {
                        <app-svg src="/assets/icons/heart-empty.svg" color="gray"> </app-svg>
                      }
                      <div class="section-name">
                        @if (grouping === 'section') {
                          <h3>{{ group.title || 'Asset Section' }}</h3>
                        } @else if (grouping === 'status') {
                          <h3>{{ group.status | assetStatusName }}</h3>
                        } @else if (grouping === 'color_label') {
                          <h3>{{ group.label?.name || 'Not Labelled' }}</h3>
                        } @else if (grouping === 'likes') {
                          <h3>
                            @if (group.likes > 0) {
                              <span>Favorited</span>
                            } @else {
                              <span>Not Favorited</span>
                            }
                          </h3>
                        }
                        <span class="asset-count">{{ group.assets.length.toString() }} Assets</span>
                      </div>
                      <div class="radio-box" (click)="stopPropagation($event)">
                        <input
                          type="checkbox"
                          id="selected-group-{{ groupIndex }}"
                          [(ngModel)]="selectedGroups['group-' + groupIndex]"
                          (ngModelChange)="handleSelectedGroupChange(group, selectedGroups['group-' + groupIndex])"
                        />
                        <label for="selected-group-{{ groupIndex }}">
                          <span class="hide-if-checked">Select</span>
                          <span class="selected hide-if-not-checked">Selected</span>
                        </label>
                      </div>
                    </div>
                  }
                  @if (dragging && dragging.pos && dragging.groupIndex === groupIndex) {
                    <div
                      class="drag-position"
                      [style.left]="dragging.pos.x + 'px'"
                      [style.top]="dragging.pos.y + 'px'"
                      [style.height]="dragging.pos.height + 'px'"
                    ></div>
                  }
                  @if (group.assets.length || !filters.length) {
                    <div
                      class="assets"
                      (document:mousemove)="mouseMove($event)"
                      (document:mouseup)="mouseUp($event)"
                      [style.--asset-width]="assetWidth"
                      [class.not-dragging]="!dragging"
                      [class.with-hover]="gallery().enabled_feedback_options?.includes('status')"
                      #assetsContainer
                      [class.empty]="!group.assets.length"
                    >
                      @for (asset of group.assets; track asset.id) {
                        <app-list-assets-item
                          [asset]="asset"
                          [gallery]="gallery()"
                          [galleryPermissions]="galleryPermissions()"
                          [colorLabels]="colorLabels()"
                          [allowedAndEnabledFeedbackOptions]="allowedAndEnabledFeedbackOptions()"
                          [inView]="inView[asset.id]"
                          [draggingAny]="!!dragging"
                          [dragging]="dragging && selectedAssets.get(asset.id)"
                          [cellSize]="cellSize"
                          [clientMode]="clientMode"
                          [isMobile]="isMobile"
                          [isDesktop]="isDesktop"
                          [darkBackground]="true"
                          [pageTransitions]="true"
                          [showFilename]="false"
                          [allowSelect]="true"
                          [selected]="selectedAssets.get(asset.id)"
                          (mousedown)="mouseDown($event, asset)"
                          (click)="stopPropagation($event)"
                          (assetSelect)="assetSelectClick(asset, $event)"
                          (assetClick)="assetClick(asset)"
                          (toggleAssetLike)="toggleAssetLike(asset)"
                          (updateAssetColorLabel)="updateAssetColorLabel(asset, $event)"
                          (updateAssetStatus)="updateAssetStatus(asset, $event)"
                        ></app-list-assets-item>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          }
        </app-drop>
      }
    </div>
  </div>
}
@if (selectedAssetsCount > 0 && !dragging) {
  <div class="selected-assets-actions-container" [@selectedAssetsActions]>
    <div class="selected-assets-actions spaced-button-group spaced-button-group-round with-shadow">
      <!-- Selected asset count -->
      <div class="spaced-button-group-item item-under">
        <div class="asset-count-container">
          <div class="asset-count"><app-smooth-counter [value]="selectedAssetsCount"></app-smooth-counter></div>
          <div class="asset-count-extra" *onlyForScreens="['desktop', 'tablet']">
            @if (selectedAssetsCount !== 1) {
              <span>Assets Selected</span>
            } @else {
              <span>Asset Selected</span>
            }
          </div>
        </div>
      </div>
      <!-- Feedback-->
      @if (showSelectedActions()) {
        <div class="spaced-button-group-item">
          <!-- Favorites-->
          @if (allowedAndEnabledFeedbackOptions().includes('favourite')) {
            <button
              appButton
              name="toggle-like"
              location="advanced-mode-selected-assets"
              data-test-id="selected-assets-favorite"
              [iconButton]="true"
              color="simple"
              height="1"
              shape="round"
              appTooltip="Favorite"
              tooltipKeyboardShortcut="F"
              (click)="toggleLikeSelectedAssets()"
            >
              @if (selectedCombined) {
                @if (!selectedCombined.is_liked) {
                  <app-svg src="/assets/icons/heart-empty.svg"></app-svg>
                } @else {
                  <app-svg src="/assets/icons/heart-filled.svg" color="warn"> </app-svg>
                }
              }
            </button>
          }
          <!-- Status -->
          @if (allowedAndEnabledFeedbackOptions().includes('status')) {
            <app-context-menu [options]="{ width: '300px', noSpacing: true }" #statusMenu name="selected-assets-status">
              <button
                appButton
                name="status-dropdown"
                location="advanced-mode-selected-assets"
                contextButton
                [iconButton]="true"
                color="simple"
                shape="round"
                height="1"
                appTooltip="Change Status"
              >
                <app-svg
                  [src]="
                    '/assets/icons/' + ((selectedCombined.status | assetStatusIcon: true) || 'mixed-status') + '.svg'
                  "
                  [attr.color]="(selectedCombined.status | assetStatusColor) || 'grey-80'"
                ></app-svg>
              </button>
              <div class="button-menu" contextContent>
                <app-asset-status-button-extra-context
                  [gallery]="gallery()"
                  [currentStatus]="selectedCombined.status"
                  [location]="'advanced-mode-selected-assets'"
                  (onSelectStatus)="updateSelectedAssetStatus($event); statusMenu.close()"
                ></app-asset-status-button-extra-context>
              </div>
            </app-context-menu>
          }
          <!-- Color labels -->
          @if (allowedAndEnabledFeedbackOptions().includes('color_label')) {
            <app-context-menu
              [options]="{ width: '300px', noSpacing: true }"
              #tagMenu
              name="selected-assets-color-labels"
              appTooltip="Add a Color Label"
            >
              <button
                appButton
                name="color-labels-dropdown"
                location="advanced-mode-selected-assets"
                contextButton
                [iconButton]="true"
                color="simple"
                height="1"
                shape="round"
              >
                @if (!selectedCombined.color_label) {
                  <app-svg src="/assets/icons/color-label-outline.svg"></app-svg>
                } @else {
                  <app-svg
                    src="/assets/icons/color-label-filled.svg"
                    [attr.color]="selectedCombined.color_label"
                  ></app-svg>
                }
              </button>
              <div contextContent>
                <div class="button-menu">
                  <app-color-label-context
                    [currentColorLabel]="selectedCombined.color_label"
                    location="advanced-mode-selected-assets"
                    [colorLabels]="colorLabels()"
                    (updateColorLabel)="updateSelectedAssetColorLabel($event); tagMenu.close()"
                  ></app-color-label-context>
                </div>
              </div>
            </app-context-menu>
          }
        </div>
      }
      <div class="spaced-button-group-item">
        <app-context-menu [options]="{ width: '240px', noSpacing: true }" [verticalPosition]="'top'" #downloadSizeMenu>
          <div contextContent class="button-menu">
            @if (downloadSizeMenu.isOpen()) {
              <app-gallery-download-menu-options
                [gallery]="gallery()"
                [assets]="getSelectedItems()"
                (onDownload)="downloadSelected($event); downloadSizeMenu.close()"
              >
              </app-gallery-download-menu-options>
            }
          </div>
        </app-context-menu>
        <!-- Extra desktop buttons -->
        <ng-container *onlyForScreens="['desktop', 'tablet']">
          @if (allowDownloadSelected()) {
            <button
              appButton
              name="download"
              location="advanced-mode-selected-assets"
              [iconButton]="true"
              height="1"
              color="simple"
              shape="round"
              [class.disabled]="downloadingSelected"
              (click)="downloadSizeMenu.open()"
              appTooltip="Download"
            >
              <app-svg src="/assets/icons/download.svg"></app-svg>
            </button>
          }
          <button
            appButton
            name="export"
            location="advanced-mode-selected-assets"
            [iconButton]="true"
            height="1"
            shape="round"
            color="simple"
            appTooltip="Export Assets"
            [tooltipKeyboardShortcut]="'E'"
            [tooltipKeyboardShortcutMeta]="true"
            (click)="openExportDialog()"
          >
            <app-svg src="/assets/icons/document-text-outline.svg"></app-svg>
          </button>
        </ng-container>
        <!-- More buttons -->
        @if (galleryPermissions().can_edit || (allowDownloadSelected() && isMobile)) {
          <app-context-menu [options]="{ width: '240px', noSpacing: true }" [verticalPosition]="'top'" #dotsMenu>
            <button
              appButton
              name="more-dropdown"
              location="advanced-mode-selected-assets"
              data-test-id="selected-assets-more"
              [iconButton]="true"
              color="simple"
              height="1"
              shape="round"
              contextButton
            >
              <app-svg src="/assets/icons/dots-vertical.svg"></app-svg>
            </button>
            <div contextContent>
              <div class="button-menu">
                <!-- Extra mobile buttons -->
                <ng-container *onlyForScreens="['mobile']">
                  @if (allowDownloadSelected()) {
                    <app-button-menu-item
                      name="download"
                      location="advanced-mode-selected-assets"
                      [fullWidth]="true"
                      (click)="dotsMenu.close(); downloadSizeMenu.open()"
                      icon="download"
                    >
                      @if (!downloadingSelected) {
                        <span>Download</span>
                      }
                      @if (downloadingSelected) {
                        <span>Downloading...</span>
                      }
                    </app-button-menu-item>
                  }
                  <app-button-menu-item
                    name="export"
                    location="advanced-mode-selected-assets"
                    [fullWidth]="true"
                    icon="document-text-outline"
                    (onClick)="dotsMenu.close(); openExportDialog()"
                  >
                    Export Assets
                  </app-button-menu-item>
                </ng-container>
                @if (galleryPermissions().can_edit) {
                  <!-- Move assets -->
                  <app-button-menu-item
                    name="move"
                    location="advanced-mode-selected-assets"
                    (click)="dotsMenu.close(); moveSelectedAssets()"
                    [fullWidth]="true"
                    icon="move-out"
                  >
                    Move/Copy to (...)
                  </app-button-menu-item>
                  <!-- toggle watermark -->
                  @if (gallery().watermark) {
                    <app-button-menu-item
                      name="toggle-watermark"
                      location="advanced-mode-selected-assets"
                      (click)="dotsMenu.close(); toggleWatermarkSelectedAssets()"
                      [fullWidth]="true"
                      icon="watermark"
                    >
                      @if (getSelectedItems()[0]?.watermark_enabled) {
                        <span>Hide Watermarks</span>
                      }
                      @if (!getSelectedItems()[0]?.watermark_enabled) {
                        <span>Add Watermarks</span>
                      }
                    </app-button-menu-item>
                  }
                  @if (!gallery().watermark) {
                    <app-button-menu-item
                      name="add-watermark"
                      location="advanced-mode-selected-assets"
                      icon="watermark"
                      (click)="openWatermarkingSettings(); dotsMenu.close()"
                      [fullWidth]="true"
                    >
                      Add Watermark
                      <app-upgrade-badge location="advanced-mode" scope="asset:watermarking"></app-upgrade-badge>
                    </app-button-menu-item>
                  }
                  <div class="divider"></div>
                  <!-- Delete -->
                  <app-button-menu-item
                    name="delete"
                    location="advanced-mode-selected-assets"
                    data-test-id="selected-assets-delete"
                    (click)="dotsMenu.close(); deleteSelectedAssets()"
                    [fullWidth]="true"
                    icon="trash"
                    color="simple-warn"
                    shortcut="DEL"
                  >
                    Delete {{ selectedAssetsCount }}
                    @if (selectedAssetsCount === 1) {
                      asset
                    } @else {
                      assets
                    }
                  </app-button-menu-item>
                }
              </div>
            </div>
          </app-context-menu>
        }
        <button
          appButton
          name="unselect"
          location="advanced-mode-selected-assets"
          [iconButton]="true"
          color="simple"
          height="1"
          shape="round"
          (click)="unselectAll()"
        >
          <app-svg src="/assets/icons/cross.svg"></app-svg>
        </button>
      </div>
    </div>
  </div>
}
